/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a feature in the catalog
 * @export
 * @interface CreateFeatureRequest
 */
export interface CreateFeatureRequest {
    /**
     * Feature ID (stable identifier)
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    featureId: string;
    /**
     * Display name
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    displayName: string;
    /**
     * Description
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    description?: string;
    /**
     * Detailed description for catalog and help views
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    detailedDescription?: string;
    /**
     * Category
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    category?: string;
    /**
     * Pricing model: PER_USER, ALL_IN, METERED
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    pricingModel: string;
    /**
     * Metering dimension (if METERED)
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    meteringDimension?: string;
    /**
     * SKU
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    sku?: string;
    /**
     * Price impact in cents
     * @type {number}
     * @memberof CreateFeatureRequest
     */
    priceImpactCents?: number;
    /**
     * Release state: ALPHA, BETA, GA, PLANNED
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    releaseState: string;
    /**
     * For GA: date became GA. For ALPHA/BETA/PLANNED: target or expected release date.
     * @type {Date}
     * @memberof CreateFeatureRequest
     */
    releaseDate?: Date;
    /**
     * UI route
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    uiRoute?: string;
    /**
     * Permission required
     * @type {string}
     * @memberof CreateFeatureRequest
     */
    permissionRequired?: string;
    /**
     * Feature IDs this feature depends on
     * @type {Array<string>}
     * @memberof CreateFeatureRequest
     */
    requiresFeatures?: Array<string>;
    /**
     * Sort order
     * @type {number}
     * @memberof CreateFeatureRequest
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the CreateFeatureRequest interface.
 */
export function instanceOfCreateFeatureRequest(value: object): value is CreateFeatureRequest {
    if (!('featureId' in value) || value['featureId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('pricingModel' in value) || value['pricingModel'] === undefined) return false;
    if (!('releaseState' in value) || value['releaseState'] === undefined) return false;
    return true;
}

export function CreateFeatureRequestFromJSON(json: any): CreateFeatureRequest {
    return CreateFeatureRequestFromJSONTyped(json, false);
}

export function CreateFeatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFeatureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'featureId': json['featureId'],
        'displayName': json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'detailedDescription': json['detailedDescription'] == null ? undefined : json['detailedDescription'],
        'category': json['category'] == null ? undefined : json['category'],
        'pricingModel': json['pricingModel'],
        'meteringDimension': json['meteringDimension'] == null ? undefined : json['meteringDimension'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'priceImpactCents': json['priceImpactCents'] == null ? undefined : json['priceImpactCents'],
        'releaseState': json['releaseState'],
        'releaseDate': json['releaseDate'] == null ? undefined : (new Date(json['releaseDate'])),
        'uiRoute': json['uiRoute'] == null ? undefined : json['uiRoute'],
        'permissionRequired': json['permissionRequired'] == null ? undefined : json['permissionRequired'],
        'requiresFeatures': json['requiresFeatures'] == null ? undefined : json['requiresFeatures'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function CreateFeatureRequestToJSON(json: any): CreateFeatureRequest {
    return CreateFeatureRequestToJSONTyped(json, false);
}

export function CreateFeatureRequestToJSONTyped(value?: CreateFeatureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'featureId': value['featureId'],
        'displayName': value['displayName'],
        'description': value['description'],
        'detailedDescription': value['detailedDescription'],
        'category': value['category'],
        'pricingModel': value['pricingModel'],
        'meteringDimension': value['meteringDimension'],
        'sku': value['sku'],
        'priceImpactCents': value['priceImpactCents'],
        'releaseState': value['releaseState'],
        'releaseDate': value['releaseDate'] == null ? undefined : ((value['releaseDate']).toISOString().substring(0,10)),
        'uiRoute': value['uiRoute'],
        'permissionRequired': value['permissionRequired'],
        'requiresFeatures': value['requiresFeatures'],
        'sortOrder': value['sortOrder'],
    };
}

